import React, { useState } from 'react'
import Image from 'next/image'
import styles from './CareersSignup.module.scss'
import Cookies from 'js-cookie'
import Select, { Options, SingleValue } from 'react-select'
import CustomSelect, { Value } from '../../components/customSelect/CustomSelect'

const CareersSignup = () => {
  const hutk = Cookies.get('hubspotutk')

  const [formSubmitted, setFormSubmitted] = useState<boolean>(false)
  const [formError, setFormError] = useState<boolean>(false)

  const handleSubmit = async (event: React.SyntheticEvent) => {
    // Stop the form from submitting and refreshing the page.
    event.preventDefault()

    const target = event.target as typeof event.target & {
      email: { value: string }
    }
    // Get data from the form.
    const data = {
      email: target.email.value,
      hutk: hutk ? hutk : '',
    }

    // Send the data to the server in JSON format.
    const JSONdata = JSON.stringify(data)
    // API endpoint where we send form data.
    const endpoint = '/api/careerssignup'

    // Form the request for sending data to the server.
    const options = {
      // The method is POST because we are sending data.
      method: 'POST',
      // Tell the server we're sending JSON.
      headers: {
        'Content-Type': 'application/json',
      },
      // Body of the request is the JSON data we created above.
      body: JSONdata,
    }

    // Send the form data to our forms API on Vercel and get a response.
    const response = await fetch(endpoint, options)

    // Get the response data from server as JSON.
    // If server returns the name submitted, that means the form works.
    const result = await response.json()
    if (result.success == true) {
      setFormSubmitted(true)
      setFormError(false)
    } else {
      setFormError(true)
    }
  }

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div id="my-hubspot-form" />
        <div className={styles.form}>
          {formError && (
            <div className={styles.formError}>
              There was a problem with your submission. Please try again.
            </div>
          )}
          {!formSubmitted ? (
            <form onSubmit={handleSubmit}>
              <div className={styles.formGroup}>
                <input type="email" name="email" placeholder="Email" required />

                <button type="submit">
                  <span className={styles.linkArrow}>
                    <Image src="/arrow-black.svg" layout="fill" alt="" />
                  </span>
                </button>
              </div>
            </form>
          ) : (
            <div className={styles.formSubmitted}>
              Thanks for your interest. We will get back to you shortly.
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default CareersSignup
